module.exports = __webpack_public_path__ + "static/media/pic88.1f0890bf.jpg";